import { RouterProvider } from 'react-router-dom';
import { createAppRouter, ROUTER_FUTURE_FLAGS } from './router.js';
import { AuthProvider } from './features/auth/AuthProvider.js';

const router = createAppRouter();

export function App(): JSX.Element {
  return (
    <AuthProvider>
      <RouterProvider router={router} future={ROUTER_FUTURE_FLAGS} />
    </AuthProvider>
  );
}
